import { AppConfig } from './definitions/app-config.interface';

function updateTitle(title: string): void {
  document.title = title;
}

function updateFavicon(theme: string): void {
  const iconPath: string = `assets/favicons/favicon-${theme}.ico`;

  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/x-icon';
  link.href = iconPath;

  document.head.appendChild(link);
}

export function applyTheme(config: AppConfig): Promise<void> {
  const companyInfo = config.companyInfo;
  const theme = companyInfo.theme;

  updateFavicon(theme);
  updateTitle(companyInfo.appName);

  return Promise.resolve();
}
